import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {
  IonicApp,
  IonicErrorHandler,
  IonicModule
       } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Keyboard } from '@ionic-native/keyboard';
import { DatePicker } from '@ionic-native/date-picker';
import { Push } from '@ionic-native/push';
import { ImagePicker } from '@ionic-native/image-picker';

import { MyApp } from './app.component';
import { UserSearchPopover } from '../pages/search/user-search';
import { EmailSearchPopover } from '../pages/search/email-search';
import { SignUpPage } from '../pages/login/signup';
import { LoginPage } from '../pages/login';
import { StaffPage } from '../pages/staff/staff';
import { ProfilePage } from '../pages/profile/profile';
import { ChangePasswordPage } from '../pages/profile/change-password';
import { ApiService } from '../services/api';
import { LocalStorageService } from '../services/local-storage';
import { DataService } from '../services/data';
import { DevicePermissionsService } from '../services/device-permissions';
import { DrawResults } from '../pages/rodeo/draw-results';
import { StandardDatePipe } from '../pipes/standard-date/standard-date';
import { AlertMessager } from '../lib/alertMessager';
import { UserService } from '../services/user.service';
import { AuthenticateService } from '../services/authenticateService';
import { TimerService } from '../services/timer.service';
import { RodeoService } from '../services/rodeo.service';
import { ImageService } from '../services/image.service';
import { RodeoEventService } from '../services/rodeoEvent.service';
import { EntryService } from '../services/entry.service';
import { HorseService } from '../services/horse.service';
import { NominationService } from '../services/nomination.service';
import { RodeoInformation } from '../pages/rodeo/rodeo-information';
import { HorseSearchPopover } from '../pages/search/horse-search';
import { ManageStaffPage } from '../pages/manage/manage-staff';
import { AddHorsePage } from '../pages/horse/add-horse';
import { HorsesPage } from '../pages/horse/horses';
import { VideosPage } from '../pages/videos/videos';
import { StreamingMedia } from '@ionic-native/streaming-media';
import { VideoService } from '../services/video.service';
import { SettingsService } from '../services/settings.service';
import { FilterPage } from '../pages/filter/filter-page';
import { FilterInformation } from '../pages/filter/filter-info';
import { StatsPage } from '../pages/stats/stats';
import { StatsMorePage } from '../pages/stats/stats-more';
import { RunService } from '../services/run.service';
import { NotificationsPage } from '../pages/notifications/notifications';
import { ViewHorsePicturePage } from '../pages/horse/view-horse-picture';
import { NominationsSection } from '../pages/staff/organization/nominations/nominations'
import { RodeoManagePage } from '../pages/staff/rodeo/rodeo-manage';
import { EntriesSection } from '../pages/staff/rodeo/entries/entries';
import { MembershipsSection } from '../pages/staff/rodeo/memberships/memberships';
import { DaySheetsSection } from '../pages/staff/rodeo/draw/draw';
import { SettingsSection } from '../pages/staff/rodeo/settings/settings';
import { ScoringSection } from '../pages/staff/rodeo/scoring/scoring';
import { VideoUploadSection } from '../pages/staff/rodeo/videos/video-upload';
import { PhotoUploadSection } from '../pages/staff/rodeo/photos/photo-upload';
import { ResultsSection } from '../pages/staff/rodeo/results/results';
import { NewRunPage } from '../pages/staff/rodeo/draw/new-run';
import { RodeosPage } from '../pages/rodeo/rodeos';
import { RodeoListPage } from '../pages/staff/rodeo/rodeo-list';
import { OrganizationListPage } from '../pages/staff/organization/organization-list';
import { OrganizationPage } from '../pages/staff/organization/organization';
import { Camera } from '@ionic-native/camera';
import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { SecretarySheetsReport } from '../pages/staff/rodeo/reports/report-secretary-sheets';
import { SecretarySheetsReportIpra } from '../pages/staff/rodeo/reports/report-secretary-sheets-ipra';
import { JudgeSheetsReport } from '../pages/staff/rodeo/reports/report-judge-sheets';
import { ExhibitionsReport } from '../pages/staff/rodeo/reports/report-exhibitions';
import { UnpaidRegsReport } from '../pages/staff/rodeo/reports/report-unpaid-regs';
import { DrawSimulation } from '../pages/rodeo/draw-simulation';
import { TextMaskModule } from 'angular2-text-mask';
import { PayPal } from '@ionic-native/paypal';
import { OrgStandingsPage } from '../pages/standings/org-standings';
import { StandingsPage } from '../pages/standings/standings';
import { EntryLogsPage } from '../pages/staff/rodeo/entries/entry-logs';
import { NewMemberPage } from '../pages/staff/rodeo/memberships/new-member';
import { UserManager } from '../services/managers/user.manager';
import { OrganizationService } from '../services/organization.service';
import { IonicSelectableModule } from 'ionic-selectable';
import { PaymentService } from '../services/payment.service';
import { ForgotPasswordPage } from '../pages/login/forgot-password';
import { ResetPasswordPage } from '../pages/login/reset-password';
import { NewWinnerPage } from '../pages/staff/rodeo/results/new-winner';
import { NewMembership } from '../pages/staff/rodeo/memberships/new-membership';
import { SearchBoxComponent } from '../pages/staff/rodeo/settings/search-box.component';
import { AuthorizeNetService } from '../services/authorizeNet.service';
import { PaymentDetailsPage } from '../pages/staff/rodeo/entries/payment-details';
import { ReportsSection } from '../pages/staff/rodeo/reports/reports';
import { OrganizationReportsSection } from '../pages/staff/organization/reports/reports';
import { SummaryReport } from '../pages/staff/rodeo/reports/report-summary';
import { TurnoutListReport } from '../pages/staff/rodeo/reports/report-turnout-list';
import { DoubleBookedListReport } from '../pages/staff/rodeo/reports/report-doublebooked-list';
import { GoogleService } from '../services/google.service';
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic/v4";
import { BuddyEntry } from '../pages/buddy-entry/buddy-entry';
import { ResultsReport } from '../pages/staff/rodeo/reports/report-results';
import { NoPreferenceListReport } from '../pages/staff/rodeo/reports/report-no-preference-list';
import { Stripe } from '@ionic-native/stripe';
import { VideoPopupPage } from '../pages/videos/video-popup';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotographerMain } from '../pages/staff/photographer/photographer';
import { NewEntryPage } from '../pages/staff/rodeo/entries/new-entry';
import { RodeoSetupPage } from '../pages/staff/rodeo/rodeo-setup';
import { NewNominationPage } from '../pages/staff/organization/nominations/new-nomination';
import { SearchComponent } from '../pages/search/search.component';
import { NominationLogsPage } from '../pages/staff/organization/nominations/nomination-logs';
import { AlphaReport } from '../pages/staff/rodeo/reports/report-alpha';
import { ReportsService } from '../services/reports.service';
import { SidepotReport } from '../pages/staff/rodeo/reports/report-sidepot';
import { AnnouncerSheetsReport } from '../pages/staff/rodeo/reports/report-announcer-sheets';
import { PrintChecksComponent } from '../pages/print-checks/print-checks.component';
import { CheckStylePopover } from '../pages/print-checks/check-style-popover.component';
import { HorsesAddEntityComponent } from '../pages/horse/horses-add-entity.component';
import { EventSelectPopup } from '../pages/staff/rodeo/entries/event-select';
import { NewPayoutConfig } from '../pages/staff/rodeo/settings/new-payout-config';
import { TransactionReport } from '../pages/staff/rodeo/reports/report-transactions';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { CarryOversReport } from '../pages/staff/rodeo/reports/report-carryovers';
import { ShowSheetsReport } from '../pages/staff/rodeo/reports/report-show-sheets';
import { JudgePopup } from '../pages/staff/rodeo/settings/judge-popup';
import { JudgeService } from '../services/judge.service';
import { OffspringNominationReport } from '../pages/staff/organization/reports/report-offspring-nominations';
import { OffspringEntryReport } from '../pages/staff/organization/reports/report-offspring-entries';
import { NewStallionPage } from '../pages/staff/organization/stallions/new-stallion';
import { StallionsSection } from '../pages/staff/organization/stallions/stallions';
import { AdminPage } from '../pages/staff/admin/admin';
import { CheckInReport } from '../pages/staff/rodeo/reports/report-check-in';
import { StallionLogsPage } from '../pages/staff/organization/stallions/stallion-logs';
import { PaymentPlansReport } from '../pages/staff/rodeo/reports/report-payment-plans';
import { IndividualShowReport } from '../pages/staff/rodeo/reports/report-individual-show';
import { JudgeScoresPage } from '../pages/staff/rodeo/scoring/judge-scores';
import { SplitPayout } from '../pages/staff/rodeo/results/split-payout';
import { OrganizationSetupPage } from '../pages/staff/organization/organization-setup';
import { NewCarryOver } from '../pages/staff/rodeo/settings/new-carryover';
import { TextingSection } from '../pages/staff/admin/texting/texting';
import { NotificationService } from '../services/texting.service';
import { DrawSection } from '../pages/staff/admin/draw/draw';
import { BackNumberConfigSection } from '../pages/staff/rodeo/settings/backnumbers/backnumber-config.component';
import { BackNumberSection } from '../pages/staff/rodeo/draw/backnumbers/backnumbers.component';
import { ExtraRunsReport } from '../pages/staff/rodeo/reports/report-extra-runs';
import { RosterReport } from '../pages/staff/rodeo/reports/report-roster';
import { StaffAccessSection } from '../pages/staff/organization/staff-access/staff-access';
import { PayoutFormatPage } from '../pages/staff/rodeo/settings/payout-format/payout-format';
import { LeaderComponent } from '../pages/staff/rodeo/scoring/leader-component';
import { CattleReport } from '../pages/staff/rodeo/reports/report-cattle';
import { PurchaseOrderComponent } from '../pages/staff/rodeo/purchase-order/purchase-order.component';
import { NotificationSection } from '../pages/staff/admin/notification/notification';
import { DrawPromptPage } from '../pages/staff/rodeo/draw/draw-prompt';
import { ProgressionsSection } from '../pages/staff/rodeo/settings/progressions/progressions';
import { ProgressionSourceModal } from '../pages/staff/rodeo/settings/progressions/progression-source';
import { StockSection } from '../pages/staff/rodeo/draw/stock/stock.component';
import { StockService } from '../services/stock.service';
import { SearchBoxComponentV2 } from '../pages/staff/rodeo/settings/search-box.component.v2';
import { StockGroupPromptPage } from '../pages/staff/rodeo/draw/stock/stock-group-prompt';
import { StockPromptPage } from '../pages/staff/rodeo/draw/stock/stock-prompt';
import { StockSwapPage } from '../pages/staff/rodeo/scoring/stock-swap.component';
import {ExpenseItemService} from '../services/ExpensesItems.service'
import { PayoutsSection } from '../pages/staff/rodeo/settings/payouts/payouts';
import { ExpenseItemsComponent } from '../pages/staff/rodeo/settings/expense-items/expense-items.component';
import { NewExpenseItemComponent } from '../pages/staff/rodeo/settings/expense-items/new-expense-item.component';
import { PayoutSourceModal } from '../pages/staff/rodeo/settings/payouts/payout-source';
import { ContestantEntryReport } from '../pages/staff/organization/reports/report-contestant-entries';
import { ChangeRequestListPage } from '../pages/staff/change-requests/change-request-list';
import { ChangeRequestDetailsComponent } from '../pages/staff/change-requests/change-request-details';
import { RequestService } from '../services/request.service';
import { MembershipService } from '../services/membership.service';
import { ClassificationSection } from '../pages/staff/admin/classification/classifications';
import { ClassificationService } from '../services/classification.service'
import { ClassificationConfigurationSection } from '../pages/staff/admin/classification/configuration';
import { PublishPromptPage } from '../pages/staff/rodeo/draw/publish-prompt';
import { TeamPopupModal } from '../pages/staff/rodeo/results/teams/team-popup';
import { TeamSection } from '../pages/staff/rodeo/results/teams/teams';
import { TeamService } from '../services/team.service';
import { TeamSelectPopup } from '../pages/staff/rodeo/results/teams/team-select';
import { PointsReport } from '../pages/staff/rodeo/reports/report-points';
import { ProgressionTieBreakerModal } from '../pages/staff/rodeo/settings/progressions/progression-tiebreaker';
import { LoadCardsReportComponent } from '../pages/staff/rodeo/reports/report-load-cards';
import { PrintService } from '../services/print-service';
import { WinnerService } from '../services/winner.service';
import { PointSeriesService } from '../services/pointseries.service';
import { PointStatsApiService } from '../services/points/pointStats.api.service';
import { PointsDomainService } from '../services/points/points.domian.service';
import { PointStatsPage } from '../pages/staff/rodeo/results/points/point-stats';
import { PointStatsLogsComponent } from '../pages/staff/rodeo/results/point-stats-logs/point-stats-logs.component';
import { PointStatsReportComponent } from '../pages/staff/rodeo/reports/points/point-stats-report.component';
import { ProgressionReport } from '../pages/staff/rodeo/settings/progressions/progression-report';
import { CheckRegisterComponent } from '../pages/print-checks/check-register/check-register';
import { AddCheckRegisterComponent } from '../pages/print-checks/check-register/add-check-register/add-check-register';
import { OrganizationCheckRegisterService } from '../services/organization-check-service';
import { TextPromptPage } from '../pages/staff/rodeo/draw/text-prompt';
import { ProgressionsService } from '../services/progressions.service';
import { ErrorHandlerService } from '../services/AppInsights/error-handler';
import { MonitoringService } from '../services/AppInsights/monitoring-service';
import { PointsMonitoringService } from '../services/points/points.monitoring.service';
import { PointGenerationModalComponent } from '../pages/staff/rodeo/results/points-generation-modal/point-generation-modal.component';
import { FarmtekReader } from '../lib/farmtek-reader';
import { AuditService } from '../services/audit.service';
import { AuditHistoryPage } from '../pages/staff/audit-history/audit-history';
import { AccountGroupService } from '../services/accountGroup.service';
import { TimerPromptPage } from '../pages/staff/rodeo/scoring/timer-prompt';
import { ContestantPaidReport } from '../pages/staff/rodeo/reports/report-contestant-paid-sheet';
import { DateHelperService } from '../services/date-helper';

@NgModule({
  declarations: [
    MyApp,
    EntryLogsPage,
    UserSearchPopover,
    BuddyEntry,
    ResultsReport,
    ProgressionsSection,
    StaffAccessSection,
    EmailSearchPopover,
    NewMemberPage,
    LoginPage,
    NewMembership,
    NewEntryPage,
    HorseSearchPopover,
    NewNominationPage,
    RodeoSetupPage,
    AddHorsePage,
    NominationLogsPage,
    HorsesPage,
    PointsReport,
    ClassificationConfigurationSection,
    VideoPopupPage,
    ManageStaffPage,
    ProgressionTieBreakerModal,
    OrgStandingsPage,
    StandingsPage,
    FilterPage,
    StaffPage,
    CattleReport,
    ContestantEntryReport,
    SearchBoxComponent,
    SearchBoxComponentV2,
    IndividualShowReport,
    OffspringNominationReport,
    OffspringEntryReport,
    ProgressionSourceModal,
    ExtraRunsReport,
    RosterReport,
    SignUpPage,
    DrawResults,
    NewWinnerPage,
    LeaderComponent,
    CheckInReport,
    PhotoUploadSection,
    TextingSection,
    NotificationSection,
    TimerPromptPage,
    TransactionReport,
    SidepotReport,
    DrawSimulation,
    AlphaReport,
    ClassificationSection,
    DrawPromptPage,
    SecretarySheetsReport,
    SecretarySheetsReportIpra,
    NoPreferenceListReport,
    NewCarryOver,
    StockSection,
    OrganizationSetupPage,
    JudgeSheetsReport,
    DrawSection,
    ExhibitionsReport,
    NewStallionPage,
    PayoutFormatPage,
    StallionLogsPage,
    StallionsSection,
    AdminPage,
    ShowSheetsReport,
    UnpaidRegsReport,
    PayoutsSection,
    ReportsSection,
    OrganizationReportsSection,
    TextPromptPage,
    SummaryReport,
    TurnoutListReport,
    StockGroupPromptPage,
    TeamSelectPopup,
    StockSwapPage,
    SearchComponent,
    DoubleBookedListReport,
    RodeosPage,
    OrganizationListPage,
    TeamSection,
    TeamPopupModal,
    RodeoListPage,
    CarryOversReport,
    OrganizationPage,
    NewRunPage,
    NominationsSection,
    RodeoManagePage,
    EntriesSection,
    MembershipsSection,
    PhotographerMain,
    AnnouncerSheetsReport,
    StockPromptPage,
    SettingsSection,
    DaySheetsSection,
    EventSelectPopup,
    ScoringSection,
    VideoUploadSection,
    NewPayoutConfig,
    JudgeScoresPage,
    ResultsSection,
    ViewHorsePicturePage,
    SplitPayout,
    HorsesAddEntityComponent,
    PayoutSourceModal,
    NotificationsPage,
    FilterInformation,
    StatsPage,
    StatsMorePage,
    VideosPage,
    ProfilePage,
    ChangePasswordPage,
    StandardDatePipe,
    ProgressionReport,
    RodeoInformation,
    ForgotPasswordPage,
    ResetPasswordPage,
    PaymentDetailsPage,
    PrintChecksComponent,
    CheckStylePopover,
    TransactionReport,
    JudgePopup,
    PaymentPlansReport,
    BackNumberConfigSection,
    BackNumberSection,
    PurchaseOrderComponent,
    ExpenseItemsComponent,
    NewExpenseItemComponent,
    ChangeRequestDetailsComponent,
    ChangeRequestListPage,
    PublishPromptPage,
    LoadCardsReportComponent,
    PointStatsPage,
    PointStatsLogsComponent,
    PointStatsReportComponent,
    CheckRegisterComponent,
    AddCheckRegisterComponent,
    PointGenerationModalComponent,
    AuditHistoryPage,
    ContestantPaidReport
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TextMaskModule,
    IonicSelectableModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
        scrollPadding: false,
        scrollAssist: false,
        autoFocusAssist: false
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    EntryLogsPage,
    ResultsReport,
    UserSearchPopover,
    SearchBoxComponent,
    ProgressionSourceModal,
    NominationLogsPage,
    SearchComponent,
    EmailSearchPopover,
    TransactionReport,
    NewMembership,
    NewMemberPage,
    VideoPopupPage,
    RodeoSetupPage,
    ProgressionsSection,
    NewEntryPage,
    CheckInReport,
    PayoutFormatPage,
    ShowSheetsReport,
    BuddyEntry,
    DrawPromptPage,
    HorseSearchPopover,
    ClassificationSection,
    DrawResults,
    TeamSection,
    TextPromptPage,
    TeamPopupModal,
    OrgStandingsPage,
    StockSection,
    StockGroupPromptPage,
    ProgressionTieBreakerModal,
    NewCarryOver,
    NotificationSection,
    StandingsPage,
    PointsReport,
    TimerPromptPage,
    ClassificationConfigurationSection,
    StaffAccessSection,
    AddHorsePage,
    HorsesPage,
    CarryOversReport,
    ManageStaffPage,
    SearchBoxComponentV2,
    AnnouncerSheetsReport,
    DrawSection,
    HorsesAddEntityComponent,
    IndividualShowReport,
    SplitPayout,
    FilterPage,
    CattleReport,
    ReportsSection,
    OffspringNominationReport,
    OffspringEntryReport,
    OrganizationReportsSection,
    SidepotReport,
    NewPayoutConfig,
    SummaryReport,
    NewNominationPage,
    OrganizationSetupPage,
    ContestantEntryReport,
    StatsPage,
    StatsMorePage,
    TeamSelectPopup,
    LeaderComponent,
    SignUpPage,
    StaffPage,
    NewWinnerPage,
    RosterReport,
    DrawSimulation,
    AlphaReport,
    SecretarySheetsReport,
    SecretarySheetsReportIpra,
    NoPreferenceListReport,
    JudgeSheetsReport,
    ExhibitionsReport,
    JudgeScoresPage,
    UnpaidRegsReport,
    EventSelectPopup,
    StockSwapPage,
    DoubleBookedListReport,
    PayoutSourceModal,
    TurnoutListReport,
    PayoutsSection,
    RodeosPage,
    BackNumberConfigSection,
    BackNumberSection,
    OrganizationListPage,
    StockPromptPage,
    TextingSection,
    PhotographerMain,
    RodeoListPage,
    OrganizationPage,
    NewRunPage,
    RodeoManagePage,
    ExtraRunsReport,
    NominationsSection,
    EntriesSection,
    MembershipsSection,
    SettingsSection,
    DaySheetsSection,
    VideoUploadSection,
    PhotoUploadSection,
    ScoringSection,
    ResultsSection,
    ViewHorsePicturePage,
    NotificationsPage,
    FilterInformation,
    VideosPage,
    LoginPage,
    ProfilePage,
    ChangePasswordPage,
    RodeoInformation,
    ForgotPasswordPage,
    ResetPasswordPage,
    PaymentDetailsPage,
    PrintChecksComponent,
    CheckStylePopover,
    TransactionReport,
    JudgePopup,
    PaymentPlansReport,
    PurchaseOrderComponent,
    ExpenseItemsComponent,
    NewExpenseItemComponent,
    ChangeRequestDetailsComponent,
    ChangeRequestListPage,
    PublishPromptPage,
    LoadCardsReportComponent,
    PointStatsPage,
    PointStatsLogsComponent,
    PointStatsReportComponent,
    ProgressionReport,
    CheckRegisterComponent,
    AddCheckRegisterComponent,
    AuditHistoryPage,
    PointGenerationModalComponent,
    ContestantPaidReport
  ],
  providers: [
    FCM,
    StatusBar,
    AlertMessager,
    ImagePicker,
    SplashScreen,
    Camera,
    File,
    Stripe,
    FileTransfer,
    DatePicker,
    ApiService,
    StockService,
    MembershipService,
    ClassificationService,
    UserService,
    PhotoLibrary,
    AuthenticateService,
    AuthorizeNetService,
    GoogleService,
    PaymentService,
    RodeoService,
    ReportsService,
    RodeoEventService,
    NotificationService,
    UserManager,
    OrganizationService,
    FarmtekReader,
    EntryService,
    ImageService,
    TimerService,
    WinnerService,
    HorseService,
    TeamService,
    NominationService,
    RunService,
    VideoService,
    SettingsService,
    ProgressionsService,
    Keyboard,
    DataService,
    LocalStorageService,
    DevicePermissionsService,
    StreamingMedia,
    Push,
    PayPal,
    DatePipe,
    JudgeService,
    ExpenseItemService,
    OrganizationCheckRegisterService,
    MonitoringService,
    {provide: ErrorHandler, useClass: ErrorHandlerService},
    CurrencyPipe,
    PrintService,
    PointSeriesService,
    PointStatsApiService,
    PointsDomainService,
    RequestService,
    PointsMonitoringService,
    AuditService,
    AccountGroupService,
    DateHelperService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts